export const getBlogPostUri = post => {
  return `/${
    post?.categories?.nodes[0]?.uri?.split("/")?.[2]
  }${post.uri}`;
};
